import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { getFormatedPrice } from '../../../../helpers/getFormatedPrice';
import { hasCurrentMeasureInsurance } from '../../../../helpers/hasCurrentMeasureInsurance';
import { hasMeasureInsurance } from '../../../../helpers/measureInsurance';
import { throwError } from '../../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../../types';
import { Caption } from '../../../Common/Caption';
import { Extra } from '../../../Common/Extra';
import { Selector, SelectorItem } from '../../../Common/Selector';
import { AccountLoginModal } from '../../AccountLoginModal/AccountLoginModal';

const isProd = process.env.NODE_ENV === 'production';

type OnClick = (
  measureInsurance: number | 'no',
  measureInsurancePrice: number,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (
  measureInsurance,
  measureInsurancePrice,
  send,
) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      measureInsurance,
      measureInsurancePrice,
    },
  });

export const Ready = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    customer,
    productWithMeasurements,
    cart,
    measureInsurance: measureInsuranceProducts,
    custom: { measureInsurance },
  } = state.context;
  const customerHasMeasureInsurance = hasMeasureInsurance(cart);
  const customerHasCurrentMeasureInsurance = hasCurrentMeasureInsurance(
    customer,
  );
  const addonProduct = measureInsuranceProducts[0];

  // const openLoginPage = () => {
  //   localStorage.setItem(
  //     'productWithMeasurements',
  //     JSON.stringify(productWithMeasurements),
  //   );
  //   localStorage.setItem('productUrl', window.location.href);
  //   window.location.href = '/account/login';
  // };

  if (!addonProduct) {
    const additionalMessage = `window.measureInsurance is empty`;
    throwError(state, additionalMessage);
  }

  const addonProductId = addonProduct.first_available_variant.id;
  const insuranceUrl = `/products/${addonProduct.handle}`;
  const insuranceExtra = addonProduct.first_available_variant.price;

  return (
    <>
      {(customerHasMeasureInsurance || customerHasCurrentMeasureInsurance) && (
        <p>
          Good news! You have already added measure insurance to your cart. This
          covers all of the blinds in your order.
        </p>
      )}
      {!customerHasMeasureInsurance && !customerHasCurrentMeasureInsurance && (
        <>
          <Caption>
            <p>
              Take away the stress of ordering custom products online with{' '}
              <b>Veneta’s Measure Insurance</b>.
            </p>
            <p>
              Developed for our customers to ensure you have full confidence in
              ordering your new window furnishings without the stress of making
              a measuring mistake. With Veneta’s Measure Insurance, if a
              measurement mistake has been made, we will replace that blind or
              curtain at no cost to you!{' '}
              <a href={insuranceUrl} target="_blank" rel="noopener noreferrer">
                Click here to learn more.
              </a>
            </p>
          </Caption>
          <Selector>
            <SelectorItem
              noCol={2}
              isSelected={measureInsurance === addonProductId}
              onClick={onClick(addonProductId, insuranceExtra, send)}
              key="yes"
            >
              Yes <Extra> + {getFormatedPrice(insuranceExtra)} </Extra>
            </SelectorItem>

            <SelectorItem
              noCol={2}
              isSelected={measureInsurance === 'no'}
              onClick={onClick('no', 0, send)}
              key="no"
            >
              No
            </SelectorItem>
          </Selector>
        </>
      )}
    </>
  );
};
